/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';

type ConditionalWrapperProps = {
	condition: boolean;
	children: ReactNode;
	wrapper: ( children: ReactNode ) => ReactNode;
};

export function ConditionalWrapper( { condition, wrapper, children }: ConditionalWrapperProps ): ReactNode {
	return condition ? wrapper( children ) : children;
}
